export default __webpack_public_path__ + "locales/az/Settings.json?hash=d8914c498155b0e30773de6464679ce3";